import { useState, useEffect, useMemo } from 'react';
import { 
  FileText, 
  Search, 
  ArrowUpDown, 
  Download,
  Check,
  X,
  Clock,
  Filter,
  AlertTriangle,
  Trash2,
  Eye,
  Edit
} from 'lucide-react';
import SunEditor from 'suneditor-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge'
import { Input } from './ui/input';
import { Label } from "./ui/label";
import { ModerationInput } from './ui/moderation-input';
import { API_URL } from '../config';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from './ui/select';
import { authFetch } from '../utils/authFetch';


export function Moderation() {
    const [documents, setDocuments] = useState([]);
    const [editingDocId, setEditingDocId] = useState(null);
    const [documentSaved, setDocumentSaved] = useState(false);
    const [changedDocument, setChangedDocument] = useState({
      title: '',
      description: '',
      category: '',
      price: -1,
      image: null,
    });
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [sortBy, setSortBy] = useState('created_at');
    const [sortOrder, setSortOrder] = useState('desc');
    const [categoryFilter, setCategoryFilter] = useState('all');
    const UPLOADS_URL = API_URL.replace('/api', '');

    const [modalDoc, setModalDoc] = useState(null);


    // Категории из загрузки
    const categoriesMap = [
    { id: 'workCult', name: 'Культура работы' },
    { id: 'projManag', name: 'Управление проектами' },
    { id: 'operEff', name: 'Операционная эффективность' },
    { id: 'hr', name: 'HR' },
    { id: 'demandPlann', name: ' Планирование потребности' },
    { id: 'provisPlann', name: 'Планирование обеспечения' },
    { id: 'purch', name: 'Закупки' },
    { id: 'logic', name: 'Логистика' },
    { id: 'money', name: 'Финансы' },
    { id: 'nsi', name: 'Развитие НСИ' },
    { id: 'automat', name: 'Автоматизация' },
    { id: 'strat', name: 'Стратегия' }
    ];

    const getCategoryName = (catId) => {
      const entry = categoriesMap.find(c => c.id === catId);
      return entry ? entry.name : catId;
    };

    const fetchDocuments = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await authFetch(`${API_URL}/documents/all/authors/admin`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`Server responded ${res.status}`);
      const data = await res.json();
      setDocuments(data);
      console.log(data.map(d => d.description))
    } catch (err) {
      console.error('Ошибка при получении документов:', err);
    }
  };

  // 2) Загружаем сразу при монтировании
  useEffect(() => {
    fetchDocuments();
  }, []);

  async function deleteDoc(id) {
    if (!window.confirm("Удалить документ безвозвратно?")) return;
    const res = await authFetch(`${API_URL}/documents/${id}`, {
      method: "DELETE",
    });
    if (res.ok) {
      // setDocs(docs.filter(d => d.id !== id));
      await fetchDocuments();
    } else {
      alert("Не удалось удалить");
    }
  }


    const filteredDocuments = useMemo(() => {
        return documents
          .filter(doc => (
            (doc.title || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            doc.category.toLowerCase().includes(searchTerm.toLowerCase())
          ))
          .filter(doc => statusFilter === 'all' || doc.status === statusFilter)
          .filter(doc => categoryFilter === 'all' || doc.category === categoryFilter)
          .sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
            return sortOrder === 'asc'
              ? (aVal > bVal ? 1 : -1)
              : (aVal < bVal ? 1 : -1);
          });
      }, [documents, searchTerm, statusFilter, categoryFilter, sortBy, sortOrder]);

    const handleApprove = async id => {
    const token = localStorage.getItem('token');
    const res = await authFetch(`${API_URL}/documents/${id}/status`, {
        method: 'PATCH',
        headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status: 'approved' })
    });
    if (!res.ok) throw new Error(`Ошибка ${res.status}`);
    await fetchDocuments();
    };

    const handleReject = async (id, reason) => {
      const token = localStorage.getItem('token');
      const res = await authFetch(`${API_URL}/documents/${id}/status`, {
          method: 'PATCH',
          headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
          },
          body: JSON.stringify({ status: 'rejected', note: reason })
      });
      if (!res.ok) throw new Error(`Ошибка ${res.status}`);
      await fetchDocuments();
      };

      async function handleDownload(doc) {
        try {
          // 1. Получаем токен
          const token = localStorage.getItem('token');
          // 2. Делаем fetch к вашему API (обязательно выдавать файл через бекенд)
          const res = await authFetch(`${API_URL}/documents/${doc.id}/download`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          if (!res.ok) throw new Error(`Ошибка ${res.status}`);
          // 3. Получаем Blob и MIME‑тип
          const blob = await res.blob();
          // 4. Создаём URL
          const url = window.URL.createObjectURL(blob);
          // 5. Фиктивная ссылка для скачивания
          const a = document.createElement('a');
          a.href = url;
          // Указываем имя файла
          a.download = doc.original_name || doc.filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          // 6. Очистка
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error('Download error:', err);
          alert('Не удалось скачать файл');
        }
      }

    const formatFileSize = (bytes) => {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }

    const handleDocumentChange = async (doc) => {
      try {
        const formData = new FormData();
        formData.append('title', changedDocument.title || doc.title);
        formData.append('price', changedDocument.price || doc.price);
        formData.append('category', changedDocument.category || doc.category);
        formData.append('description', changedDocument.description || doc.description);

        if (changedDocument.image) {
          formData.append('image', changedDocument.image);
        }

        const res = await authFetch(
          `${API_URL}/admin/document/${doc.id}`,
          {
            method: 'PATCH',
            body: formData
          }
        );

        if (!res.ok) throw new Error(`Ошибка ${res.status}`);

        setDocumentSaved(true);
        resetEditState();
        setTimeout(() => setDocumentSaved(false), 3000);
        setDocuments(prev =>
          prev.map(d =>
            d.id === doc.id
              ? { ...d, ...changedDocument }
              : d
          )
        );

        await fetchDocuments();
      } catch (err) {
        console.error(err);
        setError('Не удалось сохранить изменения');
      }
    };

    const startEdit = (doc) => {
      setEditingDocId(doc.id);
      setChangedDocument({
        title: doc.title,
        description: doc.description || '',
        category: doc.category,
        price: doc.price,
        image: null
      });
    };

    const resetEditState = () => {
      setChangedDocument({
        title: '',
        description: '',
        category: '',
        price: 0,
        image: null
      });
      setEditingDocId(null);
    };

    const getStatusBadge = (status) => {
    switch (status) {
      case 'pending':
        return <Badge variant="outline" className="text-yellow-600 border-yellow-200 text-xs">На модерации</Badge>
      case 'approved':
        return <Badge className="bg-green-100 text-green-800 border-green-200 text-xs">Одобрено</Badge>
      case 'rejected':
        return <Badge variant="destructive" className="text-xs">Отклонено</Badge>
      default:
        return null
    }
  }



    return(
        <div className="p-3 sm:p-6 space-y-6 max-w-6xl mx-auto">
            {/* Header */}
            <div className="text-center space-y-2">
              <h1 className="gradient-text text-2xl sm:text-3xl font-bold">Модерация документов</h1>
              <p className="text-gray-600 text-sm sm:text-base">
                Управляйте документами, отправленными пользователями на продажу
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
              <div className="bg-white p-3 sm:p-4 rounded-lg border">
                <div className="flex items-center gap-2">
                  <FileText className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
                  <span className="text-xs sm:text-sm text-gray-600">Всего документов</span>
                </div>
                <p className="text-lg sm:text-2xl font-semibold mt-2">{documents.length}</p>
              </div>
              <div className="bg-white p-3 sm:p-4 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Clock className="h-4 w-4 sm:h-5 sm:w-5 text-yellow-600" />
                  <span className="text-xs sm:text-sm text-gray-600">На модерации</span>
                </div>
                <p className="text-lg sm:text-2xl font-semibold mt-2">{documents.filter(doc => doc.status == 'pending').length}</p>
              </div>
              <div className="bg-white p-3 sm:p-4 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-600" />
                  <span className="text-xs sm:text-sm text-gray-600">Одобрено</span>
                </div>
                <p className="text-lg sm:text-2xl font-semibold mt-2">{documents.filter(doc => doc.status == 'approved').length}</p>
              </div>
              <div className="bg-white p-3 sm:p-4 rounded-lg border">
                <div className="flex items-center gap-2">
                  <X className="h-4 w-4 sm:h-5 sm:w-5 text-red-600" />
                  <span className="text-xs sm:text-sm text-gray-600">Отклонено</span>
                </div>
                <p className="text-lg sm:text-2xl font-semibold mt-2">{documents.filter(doc => doc.status == 'rejected').length}</p>
              </div>
            </div>

            {/* Filters */}
            <div className="bg-white rounded-lg border p-4 sm:p-6">
              <div className="flex flex-col gap-3 sm:gap-4 mb-6">
                <div className="relative">
                  <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <Input
                    placeholder="Поиск по названию или автору..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 text-sm"
                  />
                </div>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                  <Select value={statusFilter} onValueChange={setStatusFilter}>
                    <SelectTrigger className="w-full sm:w-48">
                      <Filter className="h-4 w-4 mr-2" />
                      <SelectValue placeholder="Статус" />
                    </SelectTrigger>
                    <SelectContent className="bg-white shadow-lg z-50">
                      <SelectItem value="all">Все статусы</SelectItem>
                      <SelectItem value="pending">На модерации</SelectItem>
                      <SelectItem value="approved">Одобрено</SelectItem>
                      <SelectItem value="rejected">Отклонено</SelectItem>
                    </SelectContent>
                  </Select>
                  <Select value={categoryFilter} onValueChange={setCategoryFilter}>
                    <SelectTrigger className="w-full sm:w-48">
                      <SelectValue placeholder="Категория" />
                    </SelectTrigger>
                    <SelectContent className="bg-white shadow-lg z-50">
                      <SelectItem value="all">Все категории</SelectItem>
                      {categoriesMap.map(cat => (
                        <SelectItem key={cat.id} value={cat.id}>{cat.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Select value={sortBy} onValueChange={setSortBy}>
                    <SelectTrigger className="w-full sm:w-48">
                      <ArrowUpDown className="h-4 w-4 mr-2" />
                      <SelectValue placeholder="Сортировка" />
                    </SelectTrigger>
                    <SelectContent className="bg-white shadow-lg z-50">
                      <SelectItem value="created_at">Дата загрузки</SelectItem>
                      <SelectItem value="title">Название</SelectItem>
                      <SelectItem value="author">Автор</SelectItem>
                      <SelectItem value="price">Цена</SelectItem>
                    </SelectContent>
                  </Select>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                    className="w-full sm:w-auto"
                  >
                    {sortOrder === 'asc' ? '↑' : '↓'}
                  </Button>
                </div>
              </div>

              {/* Documents List */}
              <div className="space-y-4">
                {filteredDocuments.map((doc) => (
                  <div key={doc.id} className="border rounded-lg p-4 sm:p-6">
                    <div className="flex flex-col gap-2 sm:gap-3 mb-3">
                          {/* <h3 className="font-semibold text-sm sm:text-base">{doc.title}</h3> */}
                          <ModerationInput
                            id="title"
                            value={editingDocId === doc.id ? changedDocument.title : doc.title}
                            onChange={e =>
                              setChangedDocument({ ...changedDocument, title: e.target.value })
                            }
                            editing={editingDocId === doc.id}
                            className="text-2xl font-bold"
                          />
                          {getStatusBadge(doc.status)}
                        </div>
                    <div className="flex flex-col lg:items-start gap-6">
                      <div className="flex flex-col lg:flex-row lg:items-start gap-6">
                        <div className="flex-shrink-0">
                          {editingDocId === doc.id && (
                            <div className="mt-2">
                              <Label className="text-sm">Изображение</Label>
                              <Input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  setChangedDocument(prev => ({
                                    ...prev,
                                    image: e.target.files[0]
                                  }))
                                }
                              />
                            </div>
                          )}

                          {changedDocument.image ? (
                            <img
                              src={URL.createObjectURL(changedDocument.image)}
                              className="w-[236px] h-[150px] object-cover rounded border mt-2"
                            />
                          ) : doc.image_filename ? (
                            <img
                              src={`${UPLOADS_URL}/uploads/${doc.image_filename}`}
                              alt={doc.image_original_name || 'Превью'}
                              className="mb-4 w-[236px] h-[150px] rounded border"
                            />
                          ) : (
                            <div className="w-[236px] h-[150px] bg-gray-200 flex items-center justify-center rounded border">
                              <FileText className="h-8 w-8 text-gray-400" />
                            </div>
                          )}
                        </div>
                        <div className="flex-1 flex flex-col lg:justify-between gap-4">
                          <p><span className="font-bold">Дата загрузки:</span> {doc.created_at.slice(0, 10)}</p>
                          <div className='flex flex-row gap-4'>
                            <Label htmlFor="price" className="text-sm sm:text-base font-bold">
                              Цена:
                            </Label>
                            <ModerationInput
                              id="price"
                              value={editingDocId === doc.id ? changedDocument.price : doc.price}
                              onChange={e =>
                                setChangedDocument({ ...changedDocument, price: Number(e.target.value) })
                              }
                              editing={editingDocId === doc.id}
                              className="px-2"
                            />
                            ₽
                          </div>
                          {/* <p><span className="font-bold">Цена:</span> {doc.price}₽</p> */}
                          <p><span className="font-bold">Категория:</span> {getCategoryName(doc.category)}</p>
                          <p><span className="font-bold">Имя автора:</span> {doc.author_name}</p>
                          <p><span className="font-bold">Почта автора:</span> {doc.author_email}</p>
                        </div>
                        <div className="flex flex-col gap-2 lg:gap-2 lg:ml-6 ml-auto">
                          {editingDocId !== doc.id && (
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => startEdit(doc)}
                              className="text-blue-600 border-blue-200 hover:bg-blue-50 text-xs flex-1 lg:flex-none"
                            >
                              <Edit className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                              Редактировать
                            </Button>
                          )}
                          {editingDocId === doc.id && (
                            <div className="flex gap-2 mt-3">
                              <Button
                                onClick={() => handleDocumentChange(doc)}
                                className="bg-green-600 text-white"
                              >
                                Сохранить
                              </Button>

                              <Button
                                variant="outline"
                                onClick={() => {
                                  resetEditState();
                                }}
                              >
                                Отмена
                              </Button>
                            </div>
                          )}

                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setModalDoc(doc)}
                            className="text-blue-600 border-blue-200 hover:bg-blue-50 text-xs flex-1 lg:flex-none"
                          >
                            <Eye className="h-3 w-3 sm:h-4 sm:w-4" />
                            Подробнее
                          </Button>

                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handleDownload(doc)}
                            className="text-blue-600 border-blue-200 hover:bg-blue-50 text-xs flex-1 lg:flex-none"
                          >
                            <Download className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                            Скачать
                          </Button>
                          <p className='sm:text-sm text-gray'>
                            {formatFileSize(doc.file_size)}
                          </p>
                          {doc.status === 'pending' && (
                            <>
                              <Button
                                size="sm"
                                onClick={() => handleApprove(doc.id)}
                                className="bg-green-600 hover:bg-green-700 text-white text-xs flex-1 lg:flex-none"
                              >
                                <Check className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                                Одобрить
                              </Button>
                              <Button
                                variant="destructive"
                                size="sm"
                                onClick={() => {
                                  const reason = prompt('Укажите причину отклонения:')
                                  if (reason) handleReject(doc.id, reason)
                                }}
                                className="text-xs flex-1 lg:flex-none"
                              >
                                <X className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                                Отклонить
                              </Button>
                            </>
                          )}
                          {doc.status !== 'pending' && (
                            <Button
                            variant="outline"
                            size="sm"
                            onClick={() => deleteDoc(doc.id)}
                            className="text-red-600 border-red-200 hover:bg-red-50 text-xs flex-1 lg:flex-none"
                          >
                            <Trash2 className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                            Удалить
                          </Button>
                          )}
                        </div>
                      </div>
                      {editingDocId === doc.id ? (
                          <div className="grid grid-cols-1 text-gray-700 text-sm mb-4 editor-preview max-h-none overflow-visible">
                            <Label htmlFor="description">Описание</Label>

                            <SunEditor
                              height="200px"
                              setOptions={{
                                buttonList: [
                                  ['undo', 'redo'],
                                  ['formatBlock'],
                                  ['bold', 'italic', 'underline'],
                                  ['list'],
                                  ['align', 'lineHeight'],
                                  ['link', 'image'],
                                  ['removeFormat', 'fullScreen']
                                ],
                                charCounter: true,
                                maxCharCount: 3000
                              }}
                              key={editingDocId}
                              setContents={changedDocument.description}
                              onChange={(content) =>
                                setChangedDocument(prev => ({
                                  ...prev,
                                  description: content
                                }))
                              }
                              placeholder="Опишите содержание документа..."
                            />
                          </div>
                        ) : (
                          <div
                            className="grid grid-cols-1 text-gray-700 text-sm mb-4 editor-preview prose max-h-[150px] max-w-none overflow-hidden"
                            dangerouslySetInnerHTML={{ __html: doc.description }}
                          />
                        )}
                    </div>
                    {doc.status === 'rejected' && doc.moderator_note && (
                      <div className="bg-red-50 border border-red-200 rounded p-3 mb-4">
                        <p className="text-red-700 text-sm"><span className="font-medium">Причина отклонения:</span> {doc.moderator_note}</p>
                      </div>
                    )}

                  </div>
                ))}
              </div>

              {filteredDocuments.length === 0 && (
                <div className="text-center py-8">
                  <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-500">Документы не найдены</p>
                  <p className="text-sm text-gray-400 mt-1">
                    Попробуйте изменить параметры поиска или фильтры
                  </p>
                </div>
              )}
            </div>

            {modalDoc && (
              <div
                className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 w-full"
                onClick={() => setModalDoc(null)}
              >
                <div
                  className="bg-white rounded-lg shadow-lg w-full max-w-5xl mx-[20px] p-6 relative h-[85%] flex flex-col"
                  onClick={e => e.stopPropagation()}
                >
                  <button
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                    onClick={() => setModalDoc(null)}
                  >
                    ✕
                  </button>

                  {/* <h2 className="text-2xl font-semibold mb-4">{modalDoc.title}</h2> */}
                  <ModerationInput
                    id="title"
                    value={editingDocId === modalDoc.id ? changedDocument.title : modalDoc.title}
                    onChange={e =>
                      setChangedDocument({ ...changedDocument, title: e.target.value })
                    }
                    editing={editingDocId === modalDoc.id}
                    className="text-2xl font-bold mb-4"
                  />

                  <div className="flex gap-4">
                    {changedDocument.image ? (
                      <img
                        src={URL.createObjectURL(changedDocument.image)}
                        className="w-[236px] h-[150px] object-cover rounded border mt-2"
                      />
                    ) : modalDoc.image_filename ? (
                      <img
                        src={`${UPLOADS_URL}/uploads/${modalDoc.image_filename}`}
                        alt={modalDoc.image_original_name || 'Превью'}
                        className="mb-4 w-[236px] h-[150px] rounded border"
                      />
                    ) : (
                      <div className="w-[236px] h-[150px] bg-gray-200 flex items-center justify-center rounded border">
                        <FileText className="h-8 w-8 text-gray-400" />
                      </div>
                    )}

                    <div className="flex flex-col gap-2">
                      <p><strong>Категория:</strong> {getCategoryName(modalDoc.category)}</p>
                      <p><strong>Автор:</strong> {modalDoc.author_name}</p>
                      <div className='flex flex-row gap-4'>
                        <Label htmlFor="price" className="text-sm sm:text-base font-bold">
                          Цена:
                        </Label>
                        <ModerationInput
                          id="price"
                          value={editingDocId === modalDoc.id ? changedDocument.price : modalDoc.price}
                          onChange={e =>
                            setChangedDocument({ ...changedDocument, price: Number(e.target.value) })
                          }
                          editing={editingDocId === modalDoc.id}
                          className="px-2"
                        />
                        ₽
                      </div>
                      {/* <p><strong>Цена:</strong> {modalDoc.price} ₽</p> */}
                      <p><strong>Размер файла:</strong> {formatFileSize(modalDoc.file_size)}</p>
                    </div>
                    <div className='ml-auto'>
                      {editingDocId !== modalDoc.id && (
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => startEdit(modalDoc)}
                          className="text-blue-600 border-blue-200 hover:bg-blue-50 text-xs flex-1 lg:flex-none"
                        >
                          <Edit className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
                          Редактировать
                        </Button>
                      )}
                      
                      {editingDocId === modalDoc.id && (
                        <div className="flex gap-2 mt-3">
                          <Button
                            onClick={() => handleDocumentChange(modalDoc)}
                            className="bg-green-600 text-white"
                          >
                            Сохранить
                          </Button>

                          <Button
                            variant="outline"
                            onClick={() => {
                              resetEditState();
                            }}
                          >
                            Отмена
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>

                  {editingDocId === modalDoc.id ? (
                    <div className="mt-4 h-full w-full overflow-auto">
                      <Label htmlFor="description">Описание</Label>

                      <SunEditor
                        height="100%"
                        setOptions={{
                          buttonList: [
                            ['undo', 'redo'],
                            ['formatBlock'],
                            ['bold', 'italic', 'underline'],
                            ['list'],
                            ['align', 'lineHeight'],
                            ['link', 'image'],
                            ['removeFormat', 'fullScreen']
                          ],
                          charCounter: true,
                          maxCharCount: 3000
                        }}
                        key={editingDocId}
                        setContents={changedDocument.description}
                        onChange={(content) =>
                          setChangedDocument(prev => ({
                            ...prev,
                            description: content
                          }))
                        }
                        placeholder="Опишите содержание документа..."
                      />
                    </div>
                  ) : (
                    <div
                      className="prose max-w-none h-full overflow-auto"
                      dangerouslySetInnerHTML={{ __html: modalDoc.description }}
                    />
                  )}

                </div>
              </div>
            )}
          </div>
    );
}